import { useState, useEffect } from 'react';
import { SidebarProvider, SidebarInset, SidebarTrigger } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/blocks/app-sidebar';
import { HomePage } from '@/components/blocks/home-page';
import { ReceiptsPage } from '@/components/blocks/receipts-page';
import { ExpenseClaimsPage } from '@/components/blocks/expense-claims-page';
import { ReceiptTypesPage } from '@/components/blocks/receipt-types-page';
import { IntegrationsPage } from '@/components/blocks/integrations-page';
import { DataModeToggle } from '@/components/blocks/data-mode-toggle';
import { RecapIcon } from '@/components/ui/recap-icon';

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash) {
        setCurrentPage(hash);
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage />;
      case 'receipts':
        return <ReceiptsPage />;
      case 'claims':
        return <ExpenseClaimsPage />;
      case 'reports':
        return (
          <div className="flex flex-col gap-6 p-4 md:p-6">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Reports</h1>
              <p className="text-muted-foreground mt-1 text-sm md:text-base">
                View expense reports and analytics
              </p>
            </div>
            <div className="flex items-center justify-center h-64 border-2 border-dashed rounded-lg">
              <p className="text-muted-foreground">Reports coming soon...</p>
            </div>
          </div>
        );
      case 'receipt-types':
        return <ReceiptTypesPage />;
      case 'integrations':
        return <IntegrationsPage />;
      default:
        return <HomePage />;
    }
  };

  return (
    <SidebarProvider defaultOpen={isDesktop}>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <SidebarInset>
          <header className="sticky top-0 z-50 flex h-14 items-center gap-4 border-b bg-background px-4">
            <SidebarTrigger />
            <div className="flex items-center gap-2">
              <RecapIcon className="h-8 w-8" />
              <h1 className="text-lg font-semibold">Recap</h1>
            </div>
            <DataModeToggle />
          </header>
          <main className="flex-1 overflow-auto">
            {renderPage()}
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
